export default __webpack_public_path__ + "static/media/our-partner-logo-8.ab6f05ec.jpeg";